.stickyScope {
    --dispatch-lane-header-height: 1.875rem;
}

/** Single scroll container so stacked lane headers stay stuck through later lanes. */
.laneScrollBody {
    display: block;
}

.laneStickyHeader {
    position: sticky;
}

.laneStickyHeader_0 {
    top: var(--dispatch-sticky-offset, 0px);
    z-index: 4;
}

.laneStickyHeader_1 {
    top: calc(var(--dispatch-sticky-offset, 0px) + var(--dispatch-lane-header-height));
    z-index: 3;
}

.laneStickyHeader_2 {
    top: calc(var(--dispatch-sticky-offset, 0px) + 2 * var(--dispatch-lane-header-height));
    z-index: 2;
}
